import { get, put } from './requests'

export const getAPADataSourceById = (id) => get(['data-sources-apa', id], {}, {})
export const getAPADataSourcesSchema = (payload) => get(['data-sources-apa/schema'], {}, payload)
export const updateApaDataSource = (payload, id) => put(['data-sources-apa', id], {}, payload)
export const getAPADataSources = () => get(['data-sources-apa'], {}, {})
export const getAPADataSourcesByOrg = ({ env, organization_id }) =>
  get([`data-sources-apa/organization`], {}, { env, organization_id })
